import { Link } from "react-router-dom";
import { Check, ArrowRight, Sparkles } from "lucide-react";
import { Button } from "../components/ui/button";
import { Section, Eyebrow, H1, H2, Lead, FadeIn } from "../components/Primitives";

const PERKS = [
  "Unlimited register digitizations",
  "Unlimited photos per session",
  "PDF, Excel, Google Sheets & Word exports",
  "Share to WhatsApp in one tap",
  "Hindi + English handwriting recognition",
  "Cloud-saved history of every register",
  "No credit card, no signup fees, no upsells",
];

export default function PricingPage() {
  return (
    <div data-testid="page-pricing">
      <Section className="pt-24 pb-12">
        <div className="text-center">
          <FadeIn><Eyebrow>Pricing</Eyebrow></FadeIn>
          <FadeIn delay={0.05}>
            <H1 className="mx-auto mt-6 max-w-3xl">
              Free <span className="italic font-normal text-zinc-500">forever.</span> No plans, no upsells.
            </H1>
          </FadeIn>
          <FadeIn delay={0.1}>
            <Lead className="mx-auto mt-6">
              We&apos;re on a mission to retire paper registers across India — and the fastest way to get there is to charge nothing.
              Every feature, every export, every photo: free.
            </Lead>
          </FadeIn>
          <FadeIn delay={0.15}>
            <Link to="/try" data-testid="pricing-cta-free">
              <Button size="lg" className="mt-8 rounded-full bg-zinc-950 px-6 text-white hover:bg-zinc-800">
                Open the app <ArrowRight className="ml-1.5 h-4 w-4" />
              </Button>
            </Link>
          </FadeIn>
        </div>
      </Section>

      <Section className="pt-0">
        <div className="mx-auto max-w-2xl rounded-3xl border border-zinc-950 bg-zinc-950 p-10 md:p-14 text-white">
          <span className="inline-flex items-center gap-1 rounded-full bg-white/10 px-3 py-1 text-[10px] font-medium uppercase tracking-wider">
            <Sparkles className="h-3 w-3" /> The whole app, free
          </span>
          <div className="mt-5 flex items-baseline gap-1">
            <span className="font-poppins text-6xl font-bold tracking-tight">₹0</span>
            <span className="text-zinc-300">/forever</span>
          </div>
          <p className="mt-3 text-sm text-zinc-300">Made in Meerut. Built for every Indian workplace.</p>
          <ul className="mt-7 space-y-2.5">
            {PERKS.map((p) => (
              <li key={p} className="flex items-start gap-2 text-sm">
                <Check className="mt-0.5 h-4 w-4 text-white" /> {p}
              </li>
            ))}
          </ul>
          <Link to="/try" data-testid="pricing-cta-free-alt">
            <Button className="mt-8 w-full rounded-full bg-white text-zinc-950 hover:bg-zinc-100">
              Start digitizing — it&apos;s free
            </Button>
          </Link>
        </div>
      </Section>

      <Section className="pb-32 text-center">
        <H2 className="mx-auto max-w-2xl">If we ever charge, you&apos;ll be the first to know.</H2>
        <Lead className="mx-auto mt-4">For now, every photo you upload, every register you digitize and every export you download is on the house.</Lead>
        <Link to="/contact" data-testid="pricing-contact-cta">
          <Button variant="outline" className="mt-6 rounded-full border-zinc-300">Talk to us</Button>
        </Link>
      </Section>
    </div>
  );
}
